module.exports = __webpack_public_path__ + "img/top_header.7a829f29.gif";